import React from 'react';
import Modal from 'react-modal';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import Close_Icon from '../assets/images/close-button.png';

// Set app element for accessibility
Modal.setAppElement('#root');

const CustomModal = ({ isOpen, onClose, children }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <Modal
                    isOpen={isOpen}
                    onRequestClose={onClose}
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            zIndex: 1000,
                        },
                        content: {
                            border: 'none',
                            borderRadius: '10px',
                            padding: 0,
                            background: 'transparent',
                            position: 'relative',
                            inset: 0,
                        },
                    }}
                    ariaHideApp={false}
                    closeTimeoutMS={300}
                >
                    <ModalOverlay
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        onClick={onClose}
                    >
                        <CloseButton onClick={onClose}>
                            <img src={Close_Icon} alt="Close" width={'20px'} height={'20px'} />
                        </CloseButton>
                        <ModalContent
                            initial={{ opacity: 0, scale: 0.8, y: 50 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.8, y: 50 }}
                            transition={{
                                duration: 0.3,
                                ease: "easeOut",
                                type: "spring",
                                stiffness: 300,
                                damping: 30
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {children}
                        </ModalContent>
                    </ModalOverlay>
                </Modal>
            )}
        </AnimatePresence>
    );
};

export default CustomModal;

const CloseButton = styled.button`
    position: absolute;
    top: calc(10vh - 60px);
    right: calc(10vw - 60px);
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    color: #333;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    &:hover {
        background: rgba(255, 255, 255, 1);
        transform: scale(1.1);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.4);
    }
`;

const ModalOverlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalContent = styled(motion.div)`
    width: 80vw;
    height: 80vh;
    background: #000;
    border-radius: 10px;
    z-index: 1000;
    overflow: hidden;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    position: relative;
`;
